/**
 * Take a ref to an element and a sticky behavior; make the element sticky according to the behavior
 * and make it 100% high under the sticky elements above it.
 * @param ref
 * @param stickyBehavior
 */
const stickyWithFullHeight = (ref, stickyBehavior, topPadding) => params => {
  var _a;
  // Calculate the sticky position for the element.
  const stickyLayout = stickyBehavior(params);
  // Calculate the top position of the element within the viewport;
  // the sticky top position if sticky, the top of the scrolling element otherwise.
  const elementViewportTop = (_a = stickyLayout === null || stickyLayout === void 0 ? void 0 : stickyLayout.top) !== null && _a !== void 0 ? _a : params.element().viewportTop;
  // Calculate the 100% height: the viewport height minus the top position.
  const height = Math.max(0, params.viewport().height - elementViewportTop);
  if (ref.current) {
    // Set the element to its computed 100% height.
    ref.current.style.height = `${height}px`;
    if (topPadding) ref.current.style.paddingTop = topPadding;
  }
  // Make the element sticky as computed by its normal sticky behavior.
  return stickyLayout;
};

export { stickyWithFullHeight };
//# sourceMappingURL=stickyWithFullHeight.js.map
